import React from 'react';

import Header from  './components/Header';
import Hero from "./components/Hero";
import Features from './components/Features';
import CaseStudies from "./components/CaseStudies";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from  './components/Footer';

import './App.css';

function App() {
    return (
        <div className="app">
            {/* 头部导航栏 */}
            <Header />

            {/* 主要内容区域 */}
            <main className="main-content">
                {/* 英雄区域 */}
                <Hero />

                {/* 主营业务区域 */}
                <Features />

                {/* 成功案例区域 */}
                <CaseStudies />

                {/* 关于我们区域 */}
                <About />

                {/* 联系我们区域 */}
                <Contact />
            </main>

            {/* 页脚 */}
            <Footer />
        </div>
    );
}

export default App;
